import React, { FC, Fragment, useEffect, useState } from 'react';

import { DataGrid, GridColDef, GridRenderCellParams, GridToolbarContainer } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';

import styles from './PortfolioEventsTable.module.scss';
import { PortfolioEvent, PortfolioModel } from 'pages/PortfoliosPage/PortfolioModel';
import { dataGridFocusStyles, dataGridFontSizeStyles } from 'styles';

interface PortfolioEventsTableProps {
  portfolio: PortfolioModel;
  isLoading: boolean;
}

const renderEventDate = (params: GridRenderCellParams) => {
  const shortFormatOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  };

  const date = new Date(params.row.time);
  const displayDate = new Intl.DateTimeFormat('en-GB', shortFormatOptions).format(date);
  return <Fragment>{displayDate}</Fragment>;
};

const portfolioEventColumns: GridColDef[] = [
  { field: 'time', headerName: 'Time', flex: 0.25, renderCell: renderEventDate },
  { field: 'user', headerName: 'User', flex: 0.75 },
  { field: 'description', headerName: 'Message', flex: 1 },
];

const PortfolioEventsToolbar: JSX.Element = (
  <GridToolbarContainer>
    <div className={styles.eventsTableTitle}>Events</div>
  </GridToolbarContainer>
);

const PortfolioEventsTable: FC<PortfolioEventsTableProps> = (
  {
    portfolio,
    isLoading
  }
) => {

  const [displayedEvents, setDisplayedEvents] = useState<PortfolioEvent[]>([]);

  useEffect(() => {
    setDisplayedEvents(portfolio?.events || []);
  }, [portfolio]);

  return (
    <div className={styles.PortfolioEventsTable} data-testid="PortfolioEventsTable">
      <DataGrid
        rows={displayedEvents}
        columns={portfolioEventColumns}
        loading={isLoading}
        // density="compact"
        sx={{...dataGridFocusStyles, ...dataGridFontSizeStyles}}
        getRowId={(row) => new Date(row.time).getTime()}
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: () => PortfolioEventsToolbar,
        }}
      />
    </div>
  );
};

export default PortfolioEventsTable;
